import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError
} from '@reduxjs/toolkit/query'
import CONFIG from '../app-configs'
import { type RootState } from '../app/store'
import { authClearToken } from '../modules/auth/authSlice'
import { setNotification } from '../modules/shared/components/ui-widgets/uiWidgetsSlice'
import { RtkQueryHelper } from './shared/RtkQueryHelper'

const baseQuery = fetchBaseQuery({
  baseUrl: `${CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL}`,
  prepareHeaders: (headers: Headers, { getState }) => {
    const token = (getState() as RootState).authSlice.bearerAccessToken
    headers.set('authorization', token)
    return headers
  }
})

const baseQueryWithErrorHandling: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions)
  if (((result?.error) != null) && result.error.status === 401) {
    api.dispatch(authClearToken())
    api.dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(result.error) }))
  }
  // console.log(`ERROR ${result?.error?.status}`)
  if (((result?.error) != null) && result.error.status === 429) {
    api.dispatch(authClearToken())
    api.dispatch(setNotification({ open: true, severity: 'error', message: 'You have made too many requests. Please try again later.' }))
  }
  return result
}

export const PROXIMA_API_CACHE_TAGS = ['Dashboard', 'AssetHolderSettlement', 'AssetHolderProfile', 'AssetHolderFinancials']

export const proximaApi = createApi({
  reducerPath: 'proximaApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: PROXIMA_API_CACHE_TAGS,
  endpoints: () => ({})
})
